var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"img-dom",staticClass:"cpt-chat-img-lazy loadnig",attrs:{"src":_vm.default_src,"data-original":_vm.src,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }